import { fuseProvisioningConstants } from "../_redux-constants";

export function fuseProvisioningReducer(
  state = {
    fuseprovisioningListLoading: false,
    fuseprovisioningListData: null,
    fuseprovisioningListError: null,
  },
  action
) {
  switch (action.type) {
    case fuseProvisioningConstants.FUSE_PROVISIONING_LOADING:
      return Object.assign({}, state, {
        fuseprovisioningListLoading: true,
        fuseprovisioningListData: null,
        fuseprovisioningListError: null,
      });
    case fuseProvisioningConstants.FUSE_PROVISIONING_SUCCESS:
      return Object.assign({}, state, {
        fuseprovisioningListLoading: false,
        fuseprovisioningListData: action.data,
        fuseprovisioningListError: null,
      });
    case fuseProvisioningConstants.FUSE_PROVISIONING_FAILURE:
      return Object.assign({}, state, {
        fuseprovisioningListLoading: false,
        fuseprovisioningListData: null,
        fuseprovisioningListError: action.error,
      });
    default:
      return state;
  }
}
